import { useEffect, useRef, useState } from 'react';

interface DateCard {
  id: number;
  date: string;
  title: string;
  description: string;
  icon: string;
  color: string;
}

const DatesTimeline = () => {
  const dates: DateCard[] = [
    {
      id: 1,
      date: '01 Mayıs 2026 – Saat 10:00 itibarıyla',
      title: 'Stand Kurulum Günü',
      description: 'Firma standlarının kurulumu başlıyor. Kurulum için belirlenen alanlara 01 Mayıs 2026 saat 10:00 itibarıyla giriş yapılabilir.',
      icon: 'ri-store-2-line',
      color: '#C9A84C',
    },
    {
      id: 2,
      date: '02 Mayıs 2026 – Saat 08:30 itibarıyla',
      title: 'Kongre Giriş Günü',
      description: 'Kongre kapıları açılıyor. Kayıt ve karşılama işlemleri 02 Mayıs 2026 saat 08:30 itibarıyla başlayacaktır.',
      icon: 'ri-login-box-line',
      color: '#0D1B3E',
    },
    {
      id: 3,
      date: '02 – 03 Mayıs 2026',
      title: 'Kongre Merkezi',
      description: 'Genç Diş Hekimliği Derneği 2. Ulusal İstanbul Kongresi, İstanbul Atlas Üniversitesi Kongre Merkezi\'nde gerçekleştirilecektir.',
      icon: 'ri-calendar-event-line',
      color: '#C9A84C',
    },
    {
      id: 4,
      date: '02 Mayıs 2026 – Saat 18:30 itibarıyla',
      title: 'Stand Söküm Günü',
      description: 'Firma standlarının sökümü 02 Mayıs 2026 saat 18:30 itibarıyla başlayacaktır.',
      icon: 'ri-store-line',
      color: '#0D1B3E',
    },
    {
      id: 5,
      date: '03 Mayıs 2026 – Saat 18:30 itibarıyla',
      title: 'Kongre Çıkış Günü',
      description: 'Kongre 03 Mayıs 2026 saat 18:30 itibarıyla sona erecektir. Kapanış töreni ve veda.',
      icon: 'ri-logout-box-line',
      color: '#C9A84C',
    },
  ];

  const [visibleCards, setVisibleCards] = useState<number[]>([]);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observers = dates.map((_, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setVisibleCards((prev) => [...new Set([...prev, index])]);
            observer.disconnect();
          }
        },
        { threshold: 0.2 }
      );

      if (cardRefs.current[index]) {
        observer.observe(cardRefs.current[index]!);
      }

      return observer;
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [dates.length]);

  return (
    <div className="py-16 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {dates.map((item, index) => {
            const isVisible = visibleCards.includes(index);
            const delay = (index % 3) * 100;

            return (
              <div
                key={item.id}
                ref={(el) => (cardRefs.current[index] = el)}
                className="bg-white rounded-2xl border border-gray-100 hover:border-[#C9A84C]/40 shadow-sm hover:shadow-lg p-6 transition-all duration-300"
                style={{
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? 'scale(1)' : 'scale(0.9)',
                  transition: `all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) ${delay}ms`,
                }}
              >
                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ backgroundColor: `${item.color}15` }}
                  >
                    <i className={`${item.icon} text-2xl`} style={{ color: item.color }}></i>
                  </div>
                  <div className="flex-1">
                    <div
                      className="text-xs font-bold uppercase tracking-widest mb-2"
                      style={{ color: item.color }}
                    >
                      {item.date}
                    </div>
                    <h3 className="text-base font-bold text-[#0D1B3E] mb-2 leading-snug">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DatesTimeline;